<!-- ### https://amcnewshandler.amc.info/de/newsletter ### -->
<div class="container">
  <div class="row vertical-align">
    <div class="col-md-8 col-sm-8 col-xs-12">
      <h1 class="text-headline">{{getFieldLabel("nl_heading")}}</h1>
      <h2></h2>

      <div *ngIf="getFieldLabel('nl_heading_content_1') && getFieldLabel('nl_heading_content_2') &&
              getFieldLabel('nl_heading_content_3') && getFieldLabel('nl_heading_content_4') &&
              getFieldLabel('nl_heading_content_5') && getFieldLabel('nl_heading_content_6') ">
        <p>
          <strong>{{getFieldLabel("nl_heading_content_1")}}</strong>
          {{getFieldLabel("nl_heading_content_2")}}
        </p>

        <p>
          <strong>{{getFieldLabel("nl_heading_content_3")}}</strong>
        </p>
        <ul>
          <li>{{getFieldLabel("nl_heading_content_4")}}</li>
          <li>{{getFieldLabel("nl_heading_content_5")}}</li>
          <li>{{getFieldLabel("nl_heading_content_6")}}</li>
        </ul>

      </div>
    </div>
    <div class="col-md-4 col-sm-4 hidden-xs">
      <img class="img-responsive nlImg" src="{{newsletterImage}}" />
    </div>
  </div>

  <form id="newsletterForm" [formGroup]="amcContactform" (ngSubmit)="onSubmit()">

    <!-- email -->
    <div class="form-group row">
      <label controlName="nl_email" class="col-md-3 col-sm-3 col-xs-4 col-xs-12 form-label">*
        {{getFieldLabel("nl_email")}}</label>
      <div class="col-md-6 col-sm-9 col-xs-12">
        <input formControlName="email" type="email" id="email" name="email" class="styled form-text required">
      </div>
      <div
        *ngIf="getFieldContent('email').invalid && (getFieldContent('email').dirty || getFieldContent('email').touched)">
        <small class="col-md-2 col-sm-12 col-xs-12 form-label err"
          *ngIf="getFieldContent('email').errors ?.required; else templateName">{{getFieldLabel("nl_err")}}</small>
        <ng-template #templateName>
          <small class="col-md-2 col-sm-12 col-xs-12 form-label err">{{getFieldLabel("nl_err")}}</small>
        </ng-template>
      </div>
    </div>

    <!-- gender drop-down box -->
    <div class="form-group row">
      <label class="col-md-3 col-sm-3 col-xs-12 form-label">{{getFieldLabel("nl_salutation")}}</label>
      <div class="col-md-3 col-sm-9 col-xs-12">
        <select formControlName="gender" id="gender" name="gender" class="select styled form-select selectpicker">
          <option value="0" selected="selected">{{getFieldLabel("nl_salutation_choise")}}</option>
          <option value="1">{{getFieldLabel("nl_salutation_male")}}</option>
          <option value="2">{{getFieldLabel("nl_salutation_female")}}</option>
        </select>
      </div>
    </div>

    <!-- first name -->
    <div class="form-group row">
      <label class="col-md-3 col-sm-3 col-xs-12 form-label">* {{getFieldLabel("nl_firstname")}}</label>
      <div class="col-md-6 col-sm-9 col-xs-12">
        <input formControlName="firstname" type="text" id="firstname" name="firstname"
          class="styled form-text required">
      </div>

      <div *ngIf="getFieldContent('firstname').invalid && getFieldContent('firstname').touched">
        <small class="col-md-2 col-sm-12 col-xs-12 form-label err"
          *ngIf="getFieldContent('firstname').errors ?.required; else templateName">{{getFieldLabel("nl_err")}}</small>

        <ng-template #templateName>
          <small class="col-md-2 col-sm-12 col-xs-12 form-label err">{{getFieldLabel("nl_err")}}</small>
        </ng-template>
      </div>

    </div>

    <!-- lastname/lastname -->
    <div class="form-group row">
      <label class="col-md-3 col-sm-3 col-xs-12 form-label">* {{getFieldLabel("nl_surname")}}</label>
      <div class="col-md-6 col-sm-9 col-xs-12">
        <input formControlName="lastname" type="text" id="lastname" name="lastname" class="styled form-text required">
      </div>

      <div *ngIf="getFieldContent('lastname').invalid && getFieldContent('lastname').touched">
        <small class="col-md-2 col-sm-12 col-xs-12 form-label err"
          *ngIf="getFieldContent('lastname').errors ?.required; else templateName">{{getFieldLabel("nl_err")}}</small>

        <ng-template #templateName>
          <small class="col-md-2 col-sm-12 col-xs-12 form-label err">{{getFieldLabel("nl_err")}}</small>
        </ng-template>
      </div>
    </div>

    <!-- street and house number -->
    <div class="form-group row">
      <label class="col-md-3 col-sm-3 col-xs-12 form-label">* {{getFieldLabel("nl_street")}}</label>
      <div class="col-md-6 col-sm-9 col-xs-12">
        <input formControlName="street" type="text" id="street" name="street" class="styled form-text required">
      </div>
      <div *ngIf="getFieldContent('street').invalid && getFieldContent('street').touched">
        <small class="col-md-2 col-sm-12 col-xs-12 form-label err"
          *ngIf="getFieldContent('street').errors ?.required; else templateName">{{getFieldLabel("nl_err")}}</small>

        <ng-template #templateName>
          <small class="col-md-2 col-sm-12 col-xs-12 form-label err">{{getFieldLabel("nl_err")}}</small>
        </ng-template>
      </div>
    </div>

    <!-- Postal code and area of residence -->

    <div class="form-group row">
      <label class="col-md-3 col-sm-3 col-xs-12 form-label">* {{getFieldLabel("nl_postalcode")}}</label>
      <div class="col-md-2 col-sm-2 col-xs-12">
        <input formControlName="zip" type="text" id="zip" name="zip" class="styled form-text required">
      </div>

      <label class="col-md-1 col-sm-1 col-xs-12 form-label">* {{getFieldLabel("nl_area")}}</label>
      <div class="col-md-3 col-sm-6 col-xs-12">
        <input formControlName="area" type="text" id="area" name="area" class="styled form-text required">
      </div>

    </div>

    <div class="form-group row">
      <div class="col-md-3 col-sm-3 col-xs-12"></div>
      <div *ngIf="getFieldContent('zip').invalid && getFieldContent('zip').touched">
        <small class="col-md-2 col-sm-12 col-xs-12 form-label err"
          *ngIf="getFieldContent('zip').errors ?.required; else templateName">{{getFieldLabel("nl_err")}}</small>

        <ng-template #templateName>
          <small class="col-md-2 col-sm-12 col-xs-12 form-label err">{{getFieldLabel("nl_err")}}</small>
        </ng-template>
      </div>

      <div class="col-md-1 col-sm-1 col-xs-12"></div>
      <div *ngIf="getFieldContent('area').invalid && getFieldContent('area').touched">
        <small class="col-md-2 col-sm-12 col-xs-12 form-label err"
          *ngIf="getFieldContent('area').errors ?.required; else templateName">{{getFieldLabel("nl_err")}}</small>

        <ng-template #templateName>
          <small class="col-md-2 col-sm-12 col-xs-12 form-label err">{{getFieldLabel("nl_err")}}</small>
        </ng-template>
      </div>

    </div>

    <!-- Mobile number -->
    <div class="form-group row">
      <label class="col-md-3 col-sm-3 col-xs-12 form-label">{{getFieldLabel("nl_mobile")}}</label>
      <div class="col-md-6 col-sm-9 col-xs-12">
        <input formControlName="mobilenumber" type="text" id="mobilenumber" name="mobilenumber"
          class="styled form-text">
      </div>
      <div *ngIf="getFieldContent('mobilenumber').invalid && getFieldContent('mobilenumber').touched">
        <small class="col-md-2 col-sm-12 col-xs-12 form-label err">
          {{getFieldLabel("nl_err")}}
        </small>
      </div>
    </div>
    <!-- Checkbox for privacy policy -->
    <div class="form-group row">
      <div class="col-md-6 col-sm-9 col-xs-12 col-md-offset-3 col-sm-offset-3 col-xs-offset-0">
        <div class="custom-checkbox-outake">
          <label class="containerLabel">
            <input formControlName="cbAgreement" type="checkbox" id="cbAgreement" name="cbAgreement">
            <span class="checkmark"></span>
            <label>* {{getFieldLabel("nl_agreement")}}
              <a href="{{getFieldLabel('href_data_protection')}}"
                target="_blank">{{getFieldLabel("nl_privacy_policy")}}</a>
              {{getFieldLabel("nl_privacy_policy_text")}}
            </label>
          </label>
        </div>
      </div>
    </div>

    <!-- Button for for submit -->
    <div class="form-group row">
      <div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3 col-sm-offset-3 col-xs-offset-0">
        <button type="submit" id="subButtonAngular" name="subButtonAngular"
          class="button-rounded">{{getFieldLabel("nl_submit")}}</button>
      </div>
      <small id="warning-missing"
        class="col-md-2 col-sm-12 col-xs-12 form-label err hide">{{getFieldLabel("nl_err_btn")}}</small>
    </div>
  </form>

  <div class="row" *ngIf="getFieldLabel('nl_footing_content_1') && getFieldLabel('nl_footing_content_1') ">
    <div class="col-md-12 col-sm-12  col-xs-12">
      <h2></h2>
      <p>
        {{getFieldLabel("nl_footing_content_1")}}
      </p>
      <p>
        {{getFieldLabel("nl_footing_content_2")}}
      </p>
    </div>
  </div>
</div>
